import React, { useContext, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider, AuthContext } from "./contexts/AuthContext";
import HomePage from "./pages/auth/HomePage";
import LoginPage from "./pages/auth/LoginPage";
import UserListPage from "./pages/user/UserListPage";
import UserDetailPage from "./pages/user/UserDetailPage";
import UserEditPage from "./pages/user/UserEditPage";
import UsageListPage from "./pages/usage/UsageListePage";
import UsageNowPage from "./pages/usage/UsageNowPage";
import "bootstrap/dist/css/bootstrap.min.css";
import ToastMessage from "./components/alert/toastMessage";
import Header from "./components/header/Header";
import Sidebar from "./components/sidebar/Sidebar";
const AppContent = () => {
  const { alertMessage } = useContext(AuthContext);
  const isLoginPage = window.location.pathname === "/login";
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [alert, setAlert] = useState({ type: "", message: "" });
  return (
    <div className="App d-flex flex-column vh-100">
      {alertMessage && (
        <ToastMessage type={alertMessage.type} message={alertMessage.text}  onClose={() => setAlert({ type: "", message: "" })}/>
      )}
      {alert && (
        <ToastMessage type={alert.type} message={alert.message} onClose={() => setAlert({ type: "", message: "" })} style={{zIndex:"9999999"}}/>
      )}
      {!isLoginPage && <Header toggleSidebar={() => setSidebarOpen(!sidebarOpen)} />}
      <div className="d-flex flex-grow-1">
        {!isLoginPage && (
          <>
            <Sidebar isOpen={sidebarOpen} closeSidebar={() => setSidebarOpen(!sidebarOpen)} />
            <div className={`${sidebarOpen ? "with-sidebar" : "without-sidebar"}`}></div>
          </>
          
          )}
        <div className="main-content flex-grow-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage setAlert={setAlert}/>} />
            <Route path="/user/list" element={<UserListPage setAlert={setAlert}/>} />
            <Route path="/user/create" element={<UserEditPage setAlert={setAlert}/>} />
            <Route path="/user/edit/:userId" element={<UserEditPage setAlert={setAlert}/>} />
            <Route path="/usage/list" element={<UsageListPage setAlert={setAlert}/>} />
            <Route path="/usage/now" element={<UsageNowPage setAlert={setAlert}/>} />
          </Routes>
        </div>
      </div>
      <style>{`
        .main-content {
          width: auto;
          display: flex;
          justify-content: center;
          transition: margin-left 0.3s ease-in-out;
        }

        .with-sidebar {
          min-width: 250px;
        }

        .without-sidebar {
          min-width: 0;
        }

        @media (max-width: 768px) {
          .with-sidebar {
            min-width: 0;
          }
        }
      `}</style>
    </div>
  );
};

const App = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
